import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegistrationResponse {
  /**
   * Vehicle registration plate.
   */
  @observable
  licensePlate!: string;

  /**
   * Country ID.
   */
  @observable
  countryId!: string;

  @observable canBeChangedBeforeValidity?: boolean;

  @observable canBeChangedDuringValidity?: boolean;

  /** UNUSED, but necessary in ChargeManagementLicensePlateChangeViewModel */
  @observable _countryIdConfirmation?: string;

  /** UNUSED, but necessary in ChargeManagementLicensePlateChangeViewModel */
  @observable _licensePlateConfirmation?: string;
}
